import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.443 8.02 4.55 23.903c-1.029 1.838-1.66 2.979-1.98 3.82a4 4 0 0 0-.116.341q.134.032.354.066c.89.132 2.194.138 4.299.138h17.784c2.105 0 3.409-.006 4.3-.138q.22-.034.353-.066a4 4 0 0 0-.116-.34c-.32-.842-.951-1.983-1.98-3.82L18.557 8.02c-1.069-1.91-1.741-3.097-2.316-3.842a5 5 0 0 0-.241-.29 5 5 0 0 0-.24.29c-.576.745-1.248 1.932-2.317 3.842M11.35 6.849 2.459 22.73C.479 26.264-.51 28.03.263 29.349s2.796 1.318 6.845 1.318h17.784c4.049 0 6.073 0 6.846-1.318.771-1.318-.218-3.085-2.197-6.62L20.65 6.85C18.591 3.171 17.561 1.332 16 1.332c-1.562 0-2.59 1.839-4.65 5.515M14.8 20.533v-10h2.4v10zm1.2 2a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.334"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ExclamationTriangleOutlinedSize32Glyph.displayName = 'ExclamationTriangleOutlinedSize32Glyph';
